import React from 'react';
import { Link } from 'react-router-dom';
import { ArrowLeft, Search } from 'lucide-react';

const SuggestionsGrid = ({ articles }) => (
  <div data-testid="suggested-articles">
    <h2 className="text-white text-center mb-8" style={{ fontFamily: 'Bebas Neue, sans-serif', fontSize: '1.5rem', letterSpacing: '0.05em' }}>
      You Might Be Looking For
    </h2>
    <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
      {articles.map((a) => (
        <Link
          key={a.slug}
          to={`/blogs/article/${a.slug}`}
          className="group block bg-zinc-900/50 border border-zinc-800 hover:border-zinc-600 transition-all duration-300"
          data-testid={`suggested-article-${a.slug}`}
        >
          {a.featured_image && (
            <div className="aspect-video overflow-hidden">
              <img src={a.featured_image} alt={a.title} className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500" />
            </div>
          )}
          <div className="p-4">
            {a.category && (
              <span className="text-xs uppercase tracking-wider text-[#E63946] mb-2 block">{a.category}</span>
            )}
            <h3 className="text-white text-sm font-medium group-hover:text-[#00F0FF] transition-colors line-clamp-2">{a.title}</h3>
            {a.read_time && <span className="text-zinc-500 text-xs mt-2 block">{a.read_time} min read</span>}
          </div>
        </Link>
      ))}
    </div>
  </div>
);

export const ArticleNotFoundView = ({ suggestedArticles }) => (
  <main className="pt-20 min-h-screen" data-testid="article-not-found">
    <div className="container-ninja section-spacing">
      <div className="max-w-2xl mx-auto text-center mb-16">
        <div className="w-20 h-20 rounded-full bg-zinc-800/50 flex items-center justify-center mx-auto mb-6">
          <Search className="w-8 h-8 text-zinc-500" />
        </div>
        <h1 className="text-white mb-4" style={{ fontFamily: 'Bebas Neue, sans-serif', fontSize: '2.5rem' }}>
          Article Not Found
        </h1>
        <p className="text-zinc-400 mb-8">
          The article you&apos;re looking for may have been moved or is no longer available.
        </p>
        <div className="flex gap-4 justify-center">
          <Link to="/blog" className="btn-ninja inline-flex items-center gap-2" data-testid="back-to-blog-btn">
            <ArrowLeft className="w-4 h-4" /> Browse All Articles
          </Link>
        </div>
      </div>
      {suggestedArticles && suggestedArticles.length > 0 && (
        <SuggestionsGrid articles={suggestedArticles} />
      )}
    </div>
  </main>
);

export const ArticleLoadingView = () => (
  <main className="pt-20 min-h-screen">
    <div className="container-ninja section-spacing">
      <div className="animate-pulse">
        <div className="h-8 bg-zinc-800 w-1/4 mb-4 rounded"></div>
        <div className="h-12 bg-zinc-800 w-3/4 mb-8 rounded"></div>
        <div className="h-96 bg-zinc-800 mb-8 rounded"></div>
      </div>
    </div>
  </main>
);
